var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSongWave = function SvgSongWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 0.800195C8.6 0.468824 8.33137 0.200195 8 0.200195C7.66863 0.200195 7.4 0.468824 7.4 0.800195L7.4 15.2002C7.4 15.5316 7.66863 15.8002 8 15.8002C8.33137 15.8002 8.6 15.5316 8.6 15.2002L8.6 0.800195Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 5.0002C1.93137 5.0002 2.2 5.26882 2.2 5.6002L2.2 10.4002C2.2 10.7316 1.93137 11.0002 1.6 11.0002C1.26863 11.0002 1 10.7316 1 10.4002V5.6002C1 5.26882 1.26863 5.0002 1.6 5.0002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 5.0002C14.7314 5.0002 15 5.26882 15 5.6002V10.4002C15 10.7316 14.7314 11.0002 14.4 11.0002C14.0686 11.0002 13.8 10.7316 13.8 10.4002V5.6002C13.8 5.26882 14.0686 5.0002 14.4 5.0002Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 2.6002C11.5314 2.6002 11.8 2.86882 11.8 3.2002L11.8 12.8002C11.8 13.1316 11.5314 13.4002 11.2 13.4002C10.8686 13.4002 10.6 13.1316 10.6 12.8002L10.6 3.2002C10.6 2.86882 10.8686 2.6002 11.2 2.6002Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 3.2002C5.4 2.86882 5.13137 2.6002 4.8 2.6002C4.46863 2.6002 4.2 2.86882 4.2 3.2002L4.2 12.8002C4.2 13.1316 4.46863 13.4002 4.8 13.4002C5.13137 13.4002 5.4 13.1316 5.4 12.8002L5.4 3.2002Z",
    fill: "currentColor"
  })));
};
export default SvgSongWave;